var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignatureLogoWhiteBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    transform: "translate(-11.144 -3.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    transform: "translate(11.144 3.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    className: "st0",
    d: "M22.1,10.8c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4c0,0,0,0,0,0 C26.5,12.8,24.5,10.8,22.1,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    className: "st0",
    d: "M26.8,59.8c1.1,0.1,2.2,0.2,3.2,0.2C46.6,60,60,46.5,60,30C60,13.4,46.5,0,30,0S0,13.5,0,30 c0,14.3,10.2,26.6,24.2,29.4 M34.5,53c4.1-4.8,10.3-12.2,12.6-15.4c1.3-1.6,1.9-3.7,1.7-5.7c-0.3-1.5-1.1-2.8-2.3-3.7 c-0.8-0.6-11-8.4-13.1-9.6c-0.6-0.4-1.4-0.6-2.1-0.6c-1.3,0-2.4,0.6-3.2,1.6l0,0c-1.4,1.7-1.1,4.2,0.6,5.6c0,0,0,0,0,0 c0.5,0.5,4.2,4,7.4,7c2.4,2.2,0.2,5.1,0,5.4l-0.1,0.1l-9.5,15.5c-12.8-2-21.5-13.9-19.6-26.7S20.8,4.9,33.6,6.8 s21.5,13.9,19.6,26.7C51.7,43.3,44.2,51.1,34.5,53L34.5,53z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureLogoWhiteBg);
export default __webpack_public_path__ + "static/media/signature_logo_white_bg.cd7ac836.svg";
export { ForwardRef as ReactComponent };